export interface InstrumentGroupAssignInfo {
  orgId?: string;
  businessUnit?: any[];

  clear();
}

export const instrmntGrpAssignInfo: InstrumentGroupAssignInfo = {
  orgId: '',
  businessUnit: [],
  clear() {
    this.instrmntIds = [];
    this.id = '';
    this.orgId = '';
    this.businessUnit = [];
  }
};

export interface InstrumentGroupFormDataModel {
  name?: string;
  orgId?: string;
  description?: string;
  businessUnit?: any;
  securityInfoList?: any[];
  previousSecurityInfoList?: any[];
  currentEditedName?: string;
  currentEditedDescription?: string;
  currentEditedBusinessUnit?: string;
  instrumentGrpAssignInfo?: InstrumentGroupAssignInfo;
  mode?: string;
  id: '';
  ngOMSSecurityGroupsInfo?: any;
  clear();
  setData(data);
}

export const instrmntGroupFormDataModel: InstrumentGroupFormDataModel = {
  name: '',
  orgId: '',
  id: '',
  description: '',
  businessUnit: '',
  securityInfoList: [],
  previousSecurityInfoList: [],
  mode: '',
  instrumentGrpAssignInfo: instrmntGrpAssignInfo,
  clear() {
    this.id = '';
    this.name = '';
    this.currentEditedName = '';
    this.currentEditedDescription = '';
    this.currentEditedBusinessUnit = '';
    this.description = '';
    this.orgId = '';
    this.businessUnit = [];
    this.securityInfoList = [];
    this.previousSecurityInfoList = [];
    this.mode = '';
    this.instrumentGrpAssignInfo = instrmntGrpAssignInfo;
    this.instrumentGrpAssignInfo.clear();
  },

  setData(data) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.currentEditedName = data.currentEditedName !== undefined ? data.currentEditedName : (this.currentEditedName || data.name || '');
    this.currentEditedDescription = data.currentEditedDescription !== undefined ? data.currentEditedDescription : (this.currentEditedDescription || data.description || '');
    this.currentEditedBusinessUnit = data.currentEditedBusinessUnit !== undefined
      ? data.currentEditedBusinessUnit
      : (this.currentEditedBusinessUnit || data.businessUnit || '');
    this.description = data.description || '';
    this.employeeGroupAssignInfo = data.employeeGroupAssignInfo || {};
    this.orgId = data.orgId || '';
    this.businessUnit = data.businessUnit ? {name: data.businessUnit, value: data.businessUnit} : '';
    this.securityInfoList = data.securityInfoList || [];
    this.previousSecurityInfoList = data.securityInfoList || [];
     this.ngOMSSecurityGroupsInfo = data?.ngOMSSecurityGroupsInfo;
  }
};

export class InstrumentGrpStep1 {
  name = '';
  groupDesc = '';
  businessUnit = '';
}

export class InstrumentGrpStep2 {
  securityInfoList: any[] = [];
}
